import { render, staticRenderFns } from "./HeadRollCurtain.vue?vue&type=template&id=0cc0548d&scoped=true"
import script from "./HeadRollCurtain.vue?vue&type=script&lang=js"
export * from "./HeadRollCurtain.vue?vue&type=script&lang=js"
import style0 from "./HeadRollCurtain.vue?vue&type=style&index=0&id=0cc0548d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0548d",
  null
  
)

export default component.exports